module.exports = __webpack_public_path__ + "img/other_golden_halloween.32b2bd59.jpg";